export const PLANTS = {
    PEASHOOTER: {
        key: 'peashooter',
        name: '豌豆射手',
        cost: 100,
        health: 100,
        damage: 20,
        attackSpeed: 1000,
        range: 4,
        type: 'PEASHOOTER',
    },
    SUNFLOWER: {
        key: 'sunflower',
        name: '向日葵',
        cost: 50,
        health: 50,
        sunProduction: 25,
        productionInterval: 5000,
        type: 'SUNFLOWER',
    },
    WALLNUT: {
        key: 'wallnut',
        name: '坚果墙',
        cost: 50,
        health: 200,
        type: 'WALLNUT',
    },
};
